export default "__VITE_ASSET__DoeSRbsN__"